import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { NgClass } from '@angular/common';

import { ButtonSize } from '@shared/models';

type ButtonAppereance = 'secondary' | 'primary' | 'stroked' | 'flat';

@Component({
  selector: 'ui-button',
  standalone: true,
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
})
export class ButtonComponent {
  /**
   * Button text, must be translation key
   */
  label = input.required<string>();

  /**
   * Button size
   */
  size = input<ButtonSize>('l');

  /**
   * Button appereance
   */
  appereance = input<ButtonAppereance>('primary');

  /**
   * Button type
   */
  type = input<'submit' | 'reset' | 'button'>('button');

  /**
   * If button has disabled state
   */
  disabled = input<boolean>(false);

  /**
   * If button should take full width
   */
  fullWidth = input<boolean>(false);

  classList = computed<string[]>(() => {
    const classList = [`ui-button_${this.size()}`];

    if (this.fullWidth()) {
      classList.push('ui-button_full-width w-100 justify-content-center');
    }

    classList.push(`ui-button__${this.appereance()}`);

    return classList;
  });
}
